export default "__VITE_ASSET__BVZXsEe9__"